import React, { Component } from 'react'
import {connect} from 'react-redux'

import { saveCourses } from '../../actions/Courses'

import Modal from '../Modal'

const days = [
  'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'
]

const colors = [
  {value: 'orange', name: 'Arancione'},
  {value: 'deep-orange', name: 'Arancione scuro'},
  {value: 'amber', name: 'Ambra'},
  {value: 'brown', name: 'Marrone'},
  {value: 'blue-grey', name: 'Blu grigio'},
  {value: 'blue', name: 'Blu'},
  {value: 'light-blue', name: 'Blu chiaro'},
  {value: 'yellow', name: 'Giallo'},
  {value: 'lime', name: 'Lime'},
  {value: 'cyan', name: 'Ciano'},
  {value: 'purple', name: 'Porpora'},
  {value: 'deep-purple', name: 'Viola scuro'},
  {value: 'indigo', name: 'Indaco'},
  {value: 'pink', name: 'Rosa'},
  {value: 'red', name: 'Rosso'},
  {value: 'green', name: 'Verde'},
  {value: 'light-green', name: 'Verde chiaro'},
  {value: 'teal', name: 'Verde acqua'}
]

class EditCourse extends Component {
  saveCourses () {
    this.props.saveCourses(this.state)
  }
  addSchedule () {
    if (this.state.day_of_week !== '' &&
      this.state.instructorid !== '' &&
      this.state.start_time !== '' &&
      this.state.end_time !== ''
    ) {
      this.setState({
        schedule_list: this.state.schedule_list.concat({
          day_of_week: this.state.day_of_week,
          day_name: days[this.state.day_of_week - 1],
          instructorid: this.props.instructors.list[this.state.instructorid].id,
          instructor_name: this.props.instructors.list[this.state.instructorid].name,
          start_time: this.state.start_time,
          end_time: this.state.end_time
        }),
        day_of_week: '',
        instructorid: '',
        start_time: '',
        end_time: ''
      })
    }
  }
  removeSchedule (index) {
    this.setState({
      schedule_list: this.state.schedule_list.filter((i, ind) => {
        return ind !== index
      })
    })
  }
  componentWillMount () {
    const i = this.props.course
    const rnd = Math.floor((Math.random() * colors.length))
    this.setState({
      id: i.id,
      name: i.name,
      color: (i.id === null) ? colors[rnd].value : i.color,
      day_of_week: i.day_of_week,
      instructorid: i.instructorid,
      start_time: i.start_time,
      end_time: i.end_time,
      notes: i.notes,
      schedule_list: i.schedule_list
    })
  }
  render () {
    const { ajaxStatus } = this.props.courses
    const c = this.state
    return (
      <Modal>
        <h3>{(c.id !== null) ? 'Modifica' : 'Aggiungi'} corso</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <label>
          Nome
          <input
            type="text"
            placeholder="Nome"
            onChange={event => this.setState({ name: event.target.value })}
            value={c.name}
          />
        </label>
        <label>
          Colore
          <select
            onChange={event => this.setState({ color: event.target.value })}
            value={c.color}
          >
            {
              colors.map((c, index) => {
                return (
                  <option key={index} value={c.value}>
                    {c.name}
                  </option>
                )
              })
            }
          </select>
          <div className={'cc-prev ' + this.state.color}></div>
        </label>
        <label>
          Note
          <textarea placeholder="Note"
            onChange={event => this.setState({ notes: event.target.value })}
            value={c.notes}
          ></textarea>
        </label>
        <h4>aggiungi Programmazione</h4>
        <ul className="course-schedule">
          <li className="schedule-day">
            <label>
            Giorno
              <select
                onChange={event => this.setState({ day_of_week: event.target.value })}
                value={c.day_of_week}
              >
                <option value=''></option>
                <option value='1'>Lunedì</option>
                <option value='2'>Martedì</option>
                <option value='3'>Mercoledì</option>
                <option value='4'>Giovedì</option>
                <option value='5'>Venerdì</option>
                <option value='6'>Sabato</option>
                <option value='7'>Domenica</option>
              </select>
            </label>
          </li>
          <li className="schedule-instructor">
            <label>
              Istruttore
              <select
                onChange={event => this.setState({ instructorid: event.target.value })}
                value={c.instructorid}
              >
                <option value=''></option>
                {
                  this.props.instructors.list !== null && (
                    this.props.instructors.list.map((i, index) => {
                      return (
                        <option key={index} value={index}>{i.name}</option>
                      )
                    })
                  )
                }
              </select>
            </label>
          </li>
          <li className="schedule-time">
            <label>
              Ora inizio
              <input
                type="time"
                placeholder="Ora inizio"
                onChange={event => this.setState({ start_time: event.target.value })}
                value={c.start_time}
              />
            </label>
          </li>
          <li className="schedule-time">
            <label>
              Ora fine
              <input
                type="time"
                placeholder="Ora fine"
                onChange={event => this.setState({ end_time: event.target.value })}
                value={c.end_time}
              />
            </label>
          </li>
          <li className="schedule-button">
            <button
              className="lnk-submit"
              onClick={() => this.addSchedule()}
            >
              aggiungi
            </button>
          </li>
        </ul>
        <h4>Programmazione</h4>
        {
          c.schedule_list.map((s, index) => {
            return (
              <ul className="schedule-view" key={index}>
                <li>
                  {s.day_name} - {s.instructor_name} - {s.start_time}/{s.end_time}
                </li>
                <li>
                  <button
                    className="lnk-submit"
                    onClick={() => this.removeSchedule(index)}
                  >
                    elimina
                  </button>
                </li>
              </ul>
            )
          })
        }
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.saveCourses()}
            >
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveCourses })(EditCourse)



// WEBPACK FOOTER //
// ./src/components/Courses/EditCourse.js